import humanizeDuration from "humanize-duration";

const COMPACT_LANGUAGE = "igUtilsCompact";

const compactHumanizeDuration = humanizeDuration.humanizer({
  delimiter: " ",
  language: COMPACT_LANGUAGE,
  languages: {
    [COMPACT_LANGUAGE]: {
      d: () => "d",
      h: () => "h",
      m: () => "m",
      ms: () => "ms",
      s: () => "s",
    },
  },
  largest: 2,
  round: true,
  spacer: "",
});

export const formatHumanizedDuration = (
  ms: number | null | undefined
): string => {
  if (!ms || ms < 0 || !Number.isFinite(ms)) {
    return "—";
  }

  if (ms < 1000) {
    return compactHumanizeDuration(ms, { units: ["ms"] });
  }

  return compactHumanizeDuration(ms, { units: ["h", "m", "s"] });
};
